// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___EDYg8","root__message":"style-module__root__message___M58h3","root__message__text":"style-module__root__message__text___udo1F","root__message__text_link":"style-module__root__message__text_link___P21ra","root__btn":"style-module__root__btn___cejGL"};
    if(module.hot) {
      // 1729151129578
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  